	@if(isExpanded()){
	<!--TODO: use cdk-overlay instead-->
	<div class="side-menu__overlay" (click)="closeMenu()"></div>
}
<div class="side-menu"
  [class.side-menu--expanded]="isExpanded()"
  [class.side-menu--animated]="isInitiallyRendered()">
	<section class="side-menu__header">
		<section class="side-menu__header-title mat-title-medium">
					<ng-content select="app-side-menu-title"/>
		</section>
			<button mat-icon-button aria-label="menü schließen"  (click)="closeMenu()">
				<ogs-m3-icon prefix="fal" icon="xmark"/>
		</button>
		<section class="side-menu__header-content">
					<ng-content select="app-side-menu-header"/>
		</section>
	</section>
	<section class="side-menu__tabs">
		<ng-content select="app-side-menu-tab-group"/>
	</section>
	<section class="side-menu__content">
		<ng-template #userGivenTemplate>
			<ng-content select="app-side-menu-content"/>
		</ng-template>

		@if(templateToRender()){
			<!--eslint-disable-next-line @angular-template/prefer-self-closing-tags-->
			<ng-container [ngTemplateOutlet]="templateToRender()!" ></ng-container>
		}
	</section>

</div>